import {
  AddSubContractorPayload,
  Document,
  DocumentSchema,
} from "@/services/api";
import { z } from "zod";

export const SubContractorSchema = z.object({
  Id: z.number(),
  AdnocId: z.string(),
  ContractorId: z.number().optional(),
  SubContractorId: z.number(),
  CompanyNameAr: z.string(),
  CompanyNameEn: z.string(),
  PhoneNumber: z.string(),
  MobileNumber: z.string().optional(),
  AdditionalMobileNumber: z.string().optional(),
  Email: z.string().optional(),
  SPCID: z.number().optional(),
  AdditionalEmail: z.string().optional(),
  TradeLicenseExpiryDate: z.string(),
  InsuranceExpiryDate: z.string().optional(),
  TradeLicenseNumber: z.string().optional(),
  CompanyNo: z.number(),
  SubContractorCicpaId: z.number().optional(),
  AdcciMembershipNo: z.string().optional(),
  IsMainContractor: z.boolean().optional(),
  TradeLicenseDocument: DocumentSchema,
  Value: z.string(),
});

export const SubContractorsResponseSchema = z.object({
  SubContractors: z.array(SubContractorSchema),
});

export const SubContractorsFlatResponseSchema = z.array(SubContractorSchema);

export const SubContractorsSearchResponseSchema = z.object({
  Data: z.object({ SubContractors: z.array(SubContractorSchema) }),
});

export type SubContractor = z.infer<typeof SubContractorSchema>;

export type SubContractorPayload = Omit<
  SubContractor,
  "TradeLicenseDocument"
> & {
  ContractorCicpaId: number;
  TradeLicenceDocument: Document;
};

export type SubContractorsResponse = z.infer<
  typeof SubContractorsResponseSchema
>;

export type SubContractorsFlatResponse = z.infer<
  typeof SubContractorsFlatResponseSchema
>;

export type SubContractorsSearchResponse = z.infer<
  typeof SubContractorsSearchResponseSchema
>;

export interface AddSubContractorResponse {
  SubContractorDto: SubContractor;
}

export type UpdateCreateSubContractorPayload = AddSubContractorPayload;
